import {dpaVideoPreProcessor} from "./dpaVideo"
import {facebookIframePreProcessor} from "./facebookIframe"
import {facebookJsPreProcessor} from "./facebookJs"
import {giphyPreProcessor} from "./giphy"
import {glomexPreProcessor} from "./glomex"
import {infogramPreProcessor} from "./infogram"
import {instagramPreProcessor} from "./instagram"
import {jwPlayerPreProcessor} from "./jwPlayer"
import {opinaryPreProcessor} from "./opinary"
import {riddlePreProcessor} from "./riddle"
import {soundcloudPreProcessor} from "./soundcloud"
import {telegramPreProcessor} from "./telegram"
import {tiktokPreProcessor} from "./tiktok"
import {twitterPreProcessor} from "./twitter"
import {youTubePreProcessor} from "./youTube"
import {EmbedCodeExtractor} from "./types"

/**
 * The reducible extractors in the exact order of the editor-backend pre-processor chain
 * (pipeline/registry.ts) — first non-null result wins, and an input matching more than
 * one extractor MUST reduce identically on client and server, so this order is part of
 * the package contract (resolve-long-embed-codes, design D3). Server-only pre-processors
 * (tickarooLiveblog, genericIframe, customEmbedCode) are intentionally absent.
 */
export const REDUCIBLE_EXTRACTORS: readonly EmbedCodeExtractor[] = [
  facebookIframePreProcessor,
  facebookJsPreProcessor,
  instagramPreProcessor,
  telegramPreProcessor,
  tiktokPreProcessor,
  twitterPreProcessor,
  youTubePreProcessor,
  soundcloudPreProcessor,
  dpaVideoPreProcessor,
  infogramPreProcessor,
  jwPlayerPreProcessor,
  giphyPreProcessor,
  glomexPreProcessor,
  opinaryPreProcessor,
  riddlePreProcessor
]

/**
 * Client-side embed-code reduction (design D1/D6): reduce a pasted embed code to its
 * canonical provider URL so the web-embed GET request carries a short URL instead of a
 * multi-kilobyte raw code (which the CDN's ~8 KB request-URL quota would reject).
 * Only inputs that look like embed codes are attempted (mirroring the server's
 * `startsWith("<")` test in webEmbedGetHandler); anything else — plain URLs from
 * link-list ads, social search, etc. — returns null and is submitted unchanged.
 */
export function reduceEmbedCode(input: string): string | null {
  if(!input.startsWith("<")) return null
  for(const extractor of REDUCIBLE_EXTRACTORS) {
    const url = extractor(input)
    if(url != null) return url
  }
  return null
}
